export function inIFrame(): boolean {
  return window.location !== window.parent.location
}
